import { Box, Paper } from "@mui/material"
import Stack from "@mui/material/Stack"
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid"
import { useMeasure } from "@uidotdev/usehooks"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import CustomToolbar from "../components/CustomToolbar"
import Layout from "../components/Layout"
import { PageTitle } from "../components/PageTitle"
import { useQsFilters } from "../hooks/filters"
import { useVocabolariListWithTipologie } from "../hooks/vocabolari"
import { Title } from "@mui/icons-material"
import LangLink from "../components/LangLink"

const initFilters = (params: URLSearchParams) => ({
  ordering: params.get("ordering") ?? "",
  search: params.get("search") ?? "",
})

export default function Vocabolari() {
  const { filters, setFilters, uiFilters, setFiltersDebounced } = useQsFilters(initFilters)
  const { t } = useTranslation()

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "label",
        headerName: t("vocabolario.vocabolario"),
        flex: 1,
        renderCell: (params) => (
          <LangLink to={`/vocaboli?vocabolario=${params.id}`} style={{ color: "black" }}>
            {params.value}
          </LangLink>
        ),
      },
    ]
  }, [t])

  const { data, isLoading } = useVocabolariListWithTipologie({
    search: filters.search,
  })

  // const numPages = useMemo(() => {
  //   if (!data) return 1
  //   return Math.ceil(data.count / 25)
  // }, [data])

  const [ref, { height }] = useMeasure()
  const [toolbarRef, { height: toolbarHeight }] = useMeasure()
  const tableHeight = useMemo(() => {
    if (!height || !toolbarHeight) return
    return height - toolbarHeight
  }, [height, toolbarHeight])

  return (
    <Layout padding>
      <Stack sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PageTitle
            title={t("vocabolario.titolo_lista")}
            breadcrumbs={[
              {
                label: t("vocabolario.vocabolari"),
                iconType: Title,
              },
            ]}
          />
        </Box>
        <Box flexGrow={1}>
          <Paper sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CustomToolbar
              search={uiFilters.search}
              setSearch={(search) => setFiltersDebounced({ ...filters, search })}
              clearFilters={() => setFilters({ search: "" })}
              ref={toolbarRef}
            />
            <div
              style={{
                flexGrow: 1,
                overflow: "scroll",
                height: tableHeight ?? undefined,
              }}
              ref={ref}
            >
              {height && (
                <DataGrid
                  disableColumnMenu
                  // density="compact"
                  pageSizeOptions={[25]}
                  sx={{
                    padding: 2,
                    "&.MuiDataGrid-root": {
                      border: "none",
                    },
                  }}
                  localeText={{
                    noRowsLabel: t("general.nessun_dato_disponibile"),
                  }}
                  loading={isLoading}
                  slots={{
                    footer: () => (
                      <Box></Box>
                      // <Paginator numPages={numPages} page={filters.page} setPage={(page) => setFilters({ page })} />
                    ),
                    toolbar: null,
                  }}
                  rows={data ?? ([] as GridRowsProp)}
                  columns={columns}
                  onSortModelChange={(model) => {
                    if (model.length > 0) {
                      const sortSign = model[0].sort === "asc" ? "" : "-"
                      const newOrdering = `${sortSign}${model[0].field}`
                      setFilters({ ordering: newOrdering })
                    }
                  }}
                />
              )}
            </div>
          </Paper>
        </Box>
      </Stack>
    </Layout>
  )
}
